const FOCUSABLE_SELECTOR = [
  'a[href]',
  'button:not([disabled])',
  'input:not([disabled])',
  'select:not([disabled])',
  'textarea:not([disabled])',
  '[tabindex]:not([tabindex="-1"])',
].join(',');

const DEFAULT_VIEW = 'menu';

class MobileNavElement extends HTMLElement {
  connectedCallback() {
    this._views = new Map();
    this.querySelectorAll('[data-view]').forEach((view) => {
      this._views.set(view.dataset.view, view);
    });
    this._activeTrigger = null;

    this._controller = new AbortController();
    this.addEventListener('click', (event) => this._handleClick(event), {
      signal: this._controller.signal,
    });
  }

  disconnectedCallback() {
    this._controller?.abort();
  }

  _handleClick(event) {
    const trigger = event.target.closest('[data-view-target]');
    if (trigger) {
      this._activeTrigger = trigger;
      this.showView(trigger.dataset.viewTarget, { focus: true });
      return;
    }

    const back = event.target.closest('[data-ref="back"]');
    if (back) {
      this.showDefault({ focus: true });
    }
  }

  showView(name, { focus = false } = {}) {
    const target = this._views.get(name);
    if (!target) {
      return;
    }

    this._views.forEach((view, key) => {
      view.hidden = key !== name;
    });

    if (focus) {
      target.querySelector(FOCUSABLE_SELECTOR)?.focus();
    }
  }

  showDefault({ focus = false } = {}) {
    this.showView(DEFAULT_VIEW);

    if (focus) {
      this._activeTrigger?.focus();
    }

    this._activeTrigger = null;
  }

  reset() {
    this.showDefault();
  }
}

customElements.define('chh-mobile-nav', MobileNavElement);

export default MobileNavElement;
